module.exports = __webpack_public_path__ + "img/5.8bc2fb39.jpg";